import { render, staticRenderFns } from "./CaseTop.vue?vue&type=template&id=a39fc730"
import script from "./CaseTop.vue?vue&type=script&lang=js"
export * from "./CaseTop.vue?vue&type=script&lang=js"
import style0 from "./CaseTop.vue?vue&type=style&index=0&id=a39fc730&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports